import capitalize from '@material-ui/core/utils/capitalize';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getSearchUrl } from '#helpers/searchUrl';
import { getUserLocale } from '#modules/app/selectors';
import { generateUrl, generateQueryFromUrl } from '#modules/expertDirectory/helpers';
import { getIndustriesDataForAutocomplete } from '#modules/expertDirectory/selectors';
import messagesSingleItem from './messages';
import useStyles from './styles';

type Props = {
  industryField: string;
};

const IndustryField: FC<Props> = ({ industryField }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const locale = useSelector(getUserLocale)?.toLowerCase() ?? 'de-de';
  const defaultLocation = locale === 'de-de' ? 'deutschland' : 'germany';

  const industriesOptions = useSelector(getIndustriesDataForAutocomplete).sort((a, b) =>
    a.title.localeCompare(b.title),
  );

  const industryTitle = industriesOptions.find((industry) => industry.labelId === industryField)?.title ?? '';
  const link = generateUrl(industryTitle);

  const industryHoverText = formatMessage(messagesSingleItem.hoverIndustry, {
    industry: capitalize(generateQueryFromUrl(link)),
    location: capitalize(defaultLocation),
  });

  return (
    <div className={styles.industryFieldContainer}>
      <div className={styles.industryFieldLink}>
        <PeLink href={`/${locale}/${getSearchUrl(locale)}/${link}/`} title={industryHoverText}>
          <PeTypography variant="body1">{industryTitle}</PeTypography>
        </PeLink>
      </div>
    </div>
  );
};

export default IndustryField;
